// extracted by mini-css-extract-plugin
module.exports = {"root":"_3dVd6t","title":"_3as81X","titleSlot":"_1lPtk2","buttonSlot":"_1BBu_i","imageSelectorSlot":"Z7HEF3"};